import { ChoiceEnum } from "@models/choiceEnum";
import { Employee } from "@models/employee.model";
import { TeamMember } from "@models/teamMember.model";
import { proxy } from "valtio";

/*
    Reference data shared between the Team item and its member modal: the
    engagement's members plus the contacts and roles available on each side.
    Which member is being edited is component state, not store state.
*/
export const teamMemberStore = proxy<{
  employees: Employee[];
  clientEmployees: Employee[];
  clientTeamMembers: TeamMember[];
  providerTeamMembers: TeamMember[];
  clientRoles: ChoiceEnum[];
  providerRoles: ChoiceEnum[];
}>({
  employees: [],
  clientEmployees: [],
  clientTeamMembers: [],
  providerTeamMembers: [],
  clientRoles: [],
  providerRoles: [],
});
